/**
 * Section 2 Steps Enum
 * Defines the 5 steps in the Section 2 wizard
 */
export enum Section2Steps {
  EmploymentStart = 0,
  DocumentSelection = 1,
  DocumentMetadata = 2,
  AttestationSignature = 3,
  Confirmation = 4,
}

export const SECTION_2_TOTAL_STEPS = 5;
